export default __webpack_public_path__ + "static/media/pexels-sydney-troxell.9ec4dd87.jpg";